import script from "./PatientDetailsView.vue?vue&type=script&lang=ts&setup=true"
export * from "./PatientDetailsView.vue?vue&type=script&lang=ts&setup=true"

import "./PatientDetailsView.vue?vue&type=style&index=0&id=08e19bae&lang=scss"

const __exports__ = script;

export default __exports__